<template>
  <div class="coaches-wrapper">
    <h1 v-if="me.club">Coaches at {{ me.club.name }}</h1>
    <ul class="coaches">
      <li v-for="coach in coaches">
        <h2 v-if="!smallHeader">
          <router-link :to="'/coach/'+coach.id">
            <span>{{ coach.firstname }}</span> <span>{{ coach.lastname }}</span>
          </router-link>
        </h2>
        <p v-if="smallHeader"><b>
          <router-link :to="'/coach/'+coach.id">
            <span>{{ coach.firstname }}</span> <span>{{ coach.lastname }}</span>
          </router-link>
        </b></p>
        <p><b>Weapon: </b>{{ coach.weapon.join(", ") }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
  import config from "../config.js"

  export default {
    name : "coaches",
    props : [
      "hideHeader",
      "smallHeader"
    ],
    data () {
      return {
        me : {},
        coaches : []
      }
    },
    methods : {
      getData () {
        return new Promise((resolve, reject) => {
          fetch(config.baseUrl+"user/me/", {
            credentials : "include"
          }).then(e => {
            return e.json()
          }).then(j => {
            fetch(config.baseUrl+"user/coaches/list/mine/", {
              credentials : "include"
            }).then(e => {
              return e.json()
            }).then(j2 => {
              this.setData(j, j2)
              resolve()
            })
          })
        })
      },
      setData (d, d2) {
        this.me = d
        this.coaches = d2
      },
      render () {
        this.getData()
        .then(() => {
          // data back
        })
      }
    },
    created () {
      this.render()
    }
  }
</script>

<style lang="scss">
  .coaches .coaches-wrapper h1 {
    display: none;
  }
  .coaches-wrapper {
    .coaches {
      margin: 0;
      list-style: none;
      padding: 0;
      li {
        border-bottom: 1px solid #ccc;
        padding-bottom: 20px;
        margin-bottom: 20px;
        margin-top: 0;
        &:last-child {
          border-bottom: 0;
          margin-bottom: 0;
        }
        p {
          margin: 0;
        }
      }
    }
  }
</style>
